import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function PdfReducer(state = initialState.pdf, action: any) {
  switch (action.type) {
    case types.SAVE_PDF_SUCCESS:
      return action.pdf;
    default:
      return state;
  }
}
